import styled, { css, keyframes } from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const InventoryLoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
  min-height: 180px;
  flex: 1;
`;

export const InventoryLoadingLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.BLACK};
  text-align: center;
`;

export const InventoryRevealWrapper = styled.div<{ $animate?: boolean }>`
  ${({ $animate }) =>
    $animate
      ? css`
          animation: ${fadeInUp} 0.4s ease forwards;
        `
      : css`
          animation: none;
        `}
`;

export const SuggestedVehiclesContent = styled.div`
  display: flex;
  flex-direction: column;
  color: ${COLORS.BLACK};
  width: 100%;
  margin: 1.5rem 0 0 0;
  padding-top: 0.25rem;
  position: relative;
  flex: 1;
`;

export const SuggestedVehiclesCannotMakeItWorkLabel = styled.div`
  font-weight: 700;
  width: 100%;
`;

export const ViewVehiclesButton = styled.div`
  width: fit-content;
  color: white;
  font-weight: 700;
  background-color: ${COLORS.BLUE_11};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 3px 10px;

  img {
    width: 14px;
    height: 11px;
    margin-left: 0.375rem;
  }
`;

export const SuggestedVehiclesLoaderContainer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
